












































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import Glider from "glider-js";
import "glider-js/glider.css";

/**Import Cards */
import Welcome from "./cards/Welcome.vue";
import PrepareVerification from "./cards/PrepareVerification.vue";
import PrepareSelfie from "./cards/PrepareSelfie.vue";
import ChooseCountry from "./cards/ChooseCountry.vue";
import CaptureNationalIdBack from "./cards/CaptureNationalIdBack.vue";
import CaptureNationalIdFront from "./cards/CaptureNationalIdFront.vue";
import CaptureDriversLicenseFront from "./cards/CaptureDriversLicenseFront.vue";
import CaptureDriversLicenseBack from "./cards/CaptureDriversLicenseBack.vue";
import CapturePassport from "./cards/CapturePassport.vue";
import Congratulations from "./cards/Congratulations.vue";
import Placeholder from "./cards/Placeholder.vue";

@Component({
  components: {
    welcome: Welcome,
    "prepare-verification": PrepareVerification,
    "prepare-selfie": PrepareSelfie,
    "choose-country": ChooseCountry,
    "capture-national-id-back": CaptureNationalIdBack,
    "capture-national-id-front": CaptureNationalIdFront,
    "capture-drivers-license-front": CaptureDriversLicenseFront,
    "capture-drivers-license-back": CaptureDriversLicenseBack,
    "capture-passport": CapturePassport,
    congratulations: Congratulations,
    placeholder: Placeholder,
  },
})
export default class CardCarousel extends Vue {
  @Prop({ default: 0 }) readonly initialIndex!: number;
  @Ref("gliderTarget") gliderTarget!: HTMLElement;

  cards = [
    { id: "welcome-orba-one", name: "welcome" },
    { id: "prepare-verification-orba-one", name: "prepare-verification" },
    { id: "prepare-selfie-orba-one", name: "prepare-selfie" },
    { id: "choose-country-orba-one", name: "choose-country" },
    {
      id: "capture-drivers-license-front-orba-one",
      name: "capture-drivers-license-front",
    },
    {
      id: "capture-drivers-license-back-orba-one",
      name: "capture-drivers-license-back",
    },
    {
      id: "capture-national-id-front-orba-one",
      name: "capture-national-id-front",
    },
    {
      id: "capture-national-id-back-orba-one",
      name: "capture-national-id-back",
    },
    { id: "capture-passport-orba-one", name: "capture-passport" },
    { id: "congratulations-orba-one", name: "congratulations" },
    // Three empty elements are added to ensure that the user can scroll
    // to the final card
    { id: "placeholder", name: "placeholder" },
    { id: "placeholder", name: "placeholder" },
  ];

  mounted() {
    const gliderTarget = this.$refs.gliderTarget as HTMLElement;
    new Glider(gliderTarget, {
      slidesToShow: 1,
      slidesToScroll: 1,
      itemWidth: 414,
      exactWidth: true,
      duration: 0.5,
      draggable: true,
      dragVelocity: 3.3,
      scrollPropagate: false,
      eventPropagate: true,
      scrollLock: false,
      arrows: {
        prev: ".arrow-previous",
        next: ".arrow-next",
      },
    });
  }
}
